import {h, Component} from 'preact';
import invoke from 'lodash.invoke';
import shallowCompare from 'preact-shallow-compare';
import Icon from '@components/common/Icon';

const noop = () => {};

const lblKeywordItem = upi.i18n.getTextFromKey( 'lbl-keywordItem' );

class SearchInput extends Component {

    static defaultProps = {
        placeholder: lblKeywordItem,
        id: `search-suggestions-${Math.floor( Math.random() * 10000 )}`,
        search: {
            query: '',
            onInput: noop,
            onKeyPress: noop,
            onKeyDown: noop,
            onKeyUp: noop,
            onFocus: noop
        }
    };

    shouldComponentUpdate ( nextProps, nextState ) {
        return shallowCompare( this, nextProps, nextState );
    }

    onInput = e => {
        invoke( this.props.search, 'onInput', e.target.value, e );
    };
    onKeyDown = e => {
        invoke( this.props.search, 'onKeyDown', e.which, e );

        if ( e.which === 13 ) {
            invoke( this.props.search, 'onEnter', e );
        }
    };
    onKeyUp = e => {
        invoke( this.props.search, 'onKeyUp', e.which, e );
    };
    onFocus = e => {
        invoke( this.props.search, 'onFocus', e );
    };
    onClear = e => {
        this.input.focus();
        invoke( this.props.search, 'onClear', e );
    };

    render () {
        const {placeholder, id, search: {query}} = this.props;

        // console.warn( '[SearchInput] Render' );

        return (
            <span className="search-field-wrapper relative block flex-1 m-0">
                <Icon.ui name="search" className="absolute pin-l w-10 h-full p-2"/>
                <input
                    id={id}
                    data-testid="search-query-field"
                    data-hj-whitelist
                    ref={ref => this.input = ref}
                    className="w-full h-full rounded-r-none rounded-l"
                    type="text"
                    value={query}
                    onInput={this.onInput}
                    onKeyDown={this.onKeyDown}
                    onKeyUp={this.onKeyUp}
                    onFocus={this.onFocus}
                    placeholder={placeholder}
                    autocomplete="off"
                    autocapitalize="off"
                    autocorrect="off"
                    {...this.props}
                />

                {query.length > 0 &&
                <span
                    onClick={this.onClear}
                    className="cursor-pointer inline-block absolute pin-t pin-r p-2 w-8 text-center text-lg">×</span>
                }
            </span>

        );
    }
}

export default SearchInput;
